import { types } from '../page/Chapter'

export const SecondData: types = [
  {
    id: 1,
    date: '',
    problem: '',
    state: '',
    result: [''],
  },
]
